import { datadogRum } from '@datadog/browser-rum-slim';
import { CoreApplicationContext } from '@eventbrite/context-gen';
import { EBEnvs, getCurrentEnv } from '@eventbrite/feature-detection';
import { RenderGlobalNavOrUndefined } from '@eventbrite/global-nav';
import { configureStore } from '@eventbrite/redux-configure-store';
import { middleware as analyticsMiddleware } from '@eventbrite/site-analytics';
import { StatsigOptions } from '@eventbrite/statsig';
import { $FixMe } from '@eventbrite/ts-utils';
import React from 'react';
import { Provider } from 'react-redux';
import { StringifyQuery } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import thunk from 'redux-thunk';
import { ConsumerHeader } from '../../components/ConsumerHeader';
import reducer from '../../redux/reducers';
import { getInitialData } from '../../redux/reducers/utils';
import { FeatureFlags } from '../../types';
import { FooterLinksShape, PlaceObject, Suggestions } from '../../types/index';
import '../app.scss';
import { BasePage } from '../base';
import './BrowsePage.scss';
import { CityBrowseBaseScreenContainer } from './containers';

type BrowsePageProps = RouteComponentProps & {
    footerLinks: FooterLinksShape;
    app_version?: string;
    app_name: string;
    env: CoreApplicationContext['env'];
    gaSettings: any;
    buckets: any;
    locations?: {
        places: PlaceObject[];
    };
    featureFlags: FeatureFlags;

    suggestions: Suggestions;
    http_referer: StringifyQuery;
    trending_search_cities?: string[][];
    user: {
        isAuthenticated?: boolean;
        publicId?: string;
        email?: string;
        isStaff?: boolean;
    };
    request: {
        path: string;
        session_id: string;
    };
    category_article_mapping: $FixMe;
    options: StatsigOptions;
};

class BrowsePage extends React.Component<BrowsePageProps> {
    private _store: any;
    constructor(props: Readonly<BrowsePageProps>) {
        super(props);

        this._store = configureStore({
            reducer,
            initialState: getInitialData(props),
            middleware: [thunk, analyticsMiddleware(props)],
        });
    }

    componentDidMount() {
        if (getCurrentEnv(this.props) === EBEnvs.PROD) {
            datadogRum.onReady(() =>
                datadogRum.addRumGlobalContext('view.sub_app', 'browse'),
            );
        }
    }

    globalNavHeader() {
        const { env, user, featureFlags } = this.props;
        return RenderGlobalNavOrUndefined({
            config: {
                env,
                user,
                searchBar: { renderSearchBar: false },
            },
            featureFlag: featureFlags?.enableIaGlobalNav ?? false,
        });
    }

    render() {
        return (
            <Provider store={this._store}>
                <BasePage
                    {...this.props}
                    structureHeader={ConsumerHeader}
                    overrideHeader={this.globalNavHeader()}
                >
                    <div className="feed-browse-page">
                        <CityBrowseBaseScreenContainer {...this.props} />
                    </div>
                </BasePage>
            </Provider>
        );
    }
}

export default BrowsePage;
